import {
  Box,
  Button,
  Center,
  Circle,
  Divider,
  Stack,
  Flex,
  Heading,
  TableContainer,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Select,
  Square,
  Text,
  Textarea,
  useDisclosure,
  Wrap,
  Thead,
  Table,
  Td,
  Tr,
  Tbody,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { postActions, studentActions } from "../../../redux/actions";
import Custom_Button from "../Button/Custom_Button";
import * as api from "../../../services/api";
import swAlert from "sweetalert2";
import companylogo from "../../../Assets/company.png";
import profileIcon from "../../../Assets/profile_icon.png";
import moment from "moment/moment";
import Portfolio_Badge from "../Candidate_Portfolio/Portfolio_Badge";

const SearchResult = ({ role }) => {
  const [page, setPage] = useState(1);
  const [studentId, setStudentId] = useState("");
  const [selectedJobId, setSelectedJobId] = useState("");
  const [company, setCompany] = useState([]);
  const [message, setMessage] = useState("");
  const student = useSelector((state) => state.student);
  const posts = useSelector((state) => state.post.data);
  const filter = useSelector((state) => state.filters.filter);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const companyId = user.companyId;

  const levels = [
    "Foundation",
    "3D NFT Creator",
    "3D Environment Creator",
    "XR Interaction Creator",
    "Simulation Creator",
    "Ajna Creator",
  ];

  useEffect(() => {
    dispatch(studentActions.setStudents(`badge${filter}`));
  }, []);
  useEffect(() => {
    dispatch(postActions.getPosts(companyId, "active"));
  }, []);
  useEffect(() => {
    if (posts) {
      setCompany([]);
      const getCompany = async () => {
        for (let i = 0; i < posts.length; i++) {
          const companyData = await api.getCompanyById(posts[i].companyID);
          setCompany((state) => [...state, companyData.data.data.companyName]);
        }
      };
      getCompany();
    }
  }, [posts]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, [page]);
  useEffect(() => {
    setPage(1);
  }, [filter]);

  const nextHandler = async () => {
    if (page < Math.ceil(student?.total / student?.perPage)) {
      dispatch(studentActions.setStudents(`badge${filter}`, page + 1)).then(
        (_) => setPage(page + 1)
      );
    }
  };

  const prevHandler = () => {
    if (page > 1) {
      dispatch(studentActions.setStudents(`badge${filter}`, page - 1)).then(
        (_) => setPage(page - 1)
      );
    }
  };

  const statusMap = {
    open_for_work: "Open for Work",
    browsing: "Browsing",
    not_looking: "Not Looking",
  };

  const navigate = useNavigate();
  // modal 1 state
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const [selectedJob, setSelectedJob] = useState();
  const finalRef = React.useRef(null);
  const finalRef2 = React.useRef(null);
  const handleInvite = (id) => {
    setStudentId(id);
    onOpen();
  };
  const handleModalInvite = async () => {
    // onOpen2();

    // temp Code
    if (studentId) {
      await api.sendInvite(studentId, selectedJobId);
      onClose();
      swAlert.fire({
        icon: "success",
        text: "Invitation Sent...",
        timer: 1300,
      });
      // onClose2();
    }
  };
  const handleModal2Send = async () => {
    if (studentId) {
      await api.sendInvite(studentId, selectedJobId);
      onClose();
      onClose2();
    }
  };
  const handleViewProfile = (id) => {
    navigate(`/hiring/recruiter/studentprofile/${id}`);
  };

  if (student.length == 0) {
    return (
      <>
        <Flex>No Students are matching with skills</Flex>
      </>
    );
  }
  return (
    <div>
      {/* Desktop View */}
      <Box display={["none", "none", "block", "block"]}>
        <TableContainer>
          <Table variant="simple">
            <Tbody>
              {student?.data?.map((elem) => (
                // Candidate Row
                <Tr key={elem._id}>
                  <Td w={400}>
                    <Flex align="center" gap={5}>
                      {/* Picture */}
                      <Circle
                        size={10}
                        border="1px solid #D9D9D9"
                        overflow="hidden"
                      >
                        {elem.profile_photo ? (
                          <img
                            style={{ height: "100%", width: "100%" }}
                            src={elem?.profile_photo}
                            alt="profile"
                          />
                        ) : (
                          <img
                            style={{ height: "100%", width: "100%" }}
                            src={
                              "https://cdn-icons-png.flaticon.com/512/1077/1077114.png"
                            }
                            alt="profile"
                          />
                        )}
                      </Circle>
                      {/* name */}
                      <Text
                        fontSize={20}
                        fontFamily={"Roboto"}
                        fontWeight={450}
                      >
                        {elem.name}
                      </Text>
                    </Flex>
                  </Td>
                  {/* Rank */}
                  <Td>
                    <Text
                      fontSize={20}
                      fontFamily={"Roboto"}
                      fontWeight={500}
                      color={"#3C3347"}
                      letterSpacing={"0.04em"}
                    >
                      {role}
                    </Text>
                  </Td>
                  {/* Applied Date */}
                  {/* <Td>
                    <Text>{elem.inviteDate}</Text>
                  </Td> */}
                  {/* Status */}
                  <Td>
                    <Flex
                      justify={"center"}
                      py={1}
                      px={4}
                      borderRadius={20}
                      w={"fit-content"}
                      bg={
                        statusMap[elem.student_status] == "Open for Work"
                          ? "#DBF9F4"
                          : "rgba(255, 206, 1, 0.1)"
                      }
                    >
                      {statusMap[elem.student_status]}
                    </Flex>
                  </Td>
                  {/* View Profile Button */}
                  <Td w={100}>
                    <Custom_Button
                      action="View Profile"
                      fn={() => handleViewProfile(elem._id)}
                      w="52"
                    />
                  </Td>
                  {/* Invite Candidate Button */}
                  <Td w={50}>
                    <Custom_Button
                      action="Invite"
                      fn={() => handleInvite(elem._id)}
                      bg="#6C56FB"
                      color="#FFFFFF"
                      w="32"
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>

      {/*Mobile View*/}
      <Box display={["block", "block", "none", "none"]} mt={-6}>
        {student?.data?.map((elem, idx) => (
          <Box
            key={idx}
            border={"1px solid #E7E6E8;"}
            borderRadius={"15px"}
            my={4}
            px={2}
            py={8}
          >
            <Flex align={"center"} justify={"space-between"}>
              <Flex gap={4} align={"center"}>
                {/* profile */}
                <Circle size={10} border={"1px solid"} overflow="hidden">
                  {elem.profile_photo ? (
                    <img src={elem?.profile_photo} alt="profile" />
                  ) : (
                    <img
                      src={
                        "https://cdn-icons-png.flaticon.com/512/1077/1077114.png"
                      }
                      alt="profile"
                    />
                  )}
                </Circle>
                {/* name */}
                <Text fontSize={24} fontFamily={"Roboto"} fontWeight={500}>
                  {elem.name}
                </Text>
              </Flex>
              {/* menu */}

              <Popover>
                <PopoverTrigger>
                  <Circle
                    size={8}
                    border="1px solid"
                    _hover={{ background: "#D9D9D9" }}
                  >
                    <img
                      height="70%"
                      width="70%"
                      src="https://cdn-icons-png.flaticon.com/512/2311/2311524.png"
                      alt="Profile_Pic"
                    />
                  </Circle>
                </PopoverTrigger>
                <PopoverContent w={200} bg="#FFFFFF" borderRadius={10}>
                  <PopoverArrow bg="#FFFFFF" />
                  <PopoverCloseButton />
                  <PopoverBody>
                    <Flex flexDirection="column" my={5} gap={2}>
                      {/* Send Message */}
                      {/* <Flex align='center' gap={2} cursor='pointer'>
                            <Circle size={7} bg='#D9D9D9'>
                              <img src={message} alt='msg' />
                            </Circle>
                            <Box> */}
                      {/* Route to respective page */}
                      {/* <Text fontSize={18} fontWeight={400}>
                                Send Message
                              </Text>
                            </Box>
                          </Flex> */}
                      <Divider border="1px solid #DEDEDE" />
                      {/* View Profile */}
                      <Flex align="center" gap={2} cursor="pointer">
                        <Circle
                          size={7}
                          border="1px solid #CECCD1"
                          overflow={"hidden"}
                        >
                          {elem.profile_photo ? (
                            <img src={elem?.profile_photo} alt="profile" />
                          ) : (
                            <img
                              src={
                                "https://cdn-icons-png.flaticon.com/512/1077/1077114.png"
                              }
                              alt="profile"
                            />
                          )}
                        </Circle>

                        <Box
                          onClick={() => {
                            navigate(
                              `/hiring/recruiter/studentprofile/${elem.appliedBy}`
                            );
                          }}
                        >
                          <Text fontSize={18} fontWeight={400}>
                            View Profile
                          </Text>
                        </Box>
                      </Flex>
                    </Flex>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </Flex>
            <Flex
              justify={"center"}
              py={1}
              px={4}
              ml={12}
              borderRadius={20}
              w={"fit-content"}
              bg={
                statusMap[elem.student_status] == "Open for Work"
                  ? "#DBF9F4"
                  : "rgba(255, 206, 1, 0.1)"
              }
            >
              {statusMap[elem.student_status]}
            </Flex>

            {/* Badges */}
            <Box
              textAlign="left"
              w="80%"
              mt={5}
              // display={["none", "none", "block", "block"]}
            >
              <Wrap my={4}>
                {elem?.badges?.map((item) => (
                  <Portfolio_Badge
                    key={item}
                    name={levels[item]}
                    color={"#544D5E"}
                  />
                ))}
              </Wrap>
            </Box>
            {/* Invite Button */}
            <Box mt={4}>
              <Custom_Button
                action="Invite"
                fn={() => handleInvite(elem._id)}
                bg="#6C56FB"
                color="#FFFFFF"
                w="100%"
              />
            </Box>
            {/* Profile Button*/}
            <Box mt={4}>
              <Custom_Button
                action="View Profile"
                fn={() => handleViewProfile(elem._id)}
                w="100%"
              />
            </Box>
          </Box>
        ))}
      </Box>

      {/* Next and Prev Buttons */}
      <Center mt={5}>
        <Button onClick={prevHandler} disabled={page === 1}>
          Prev
        </Button>
        <Box mx={5} fontWeight="bold">
          {student?.page}/{Math.ceil(student?.total / student?.perPage)}
        </Box>
        <Button
          onClick={nextHandler}
          disabled={page === Math.ceil(student?.total / student?.perPage)}
        >
          Next
        </Button>
      </Center>
      {/* Modal 1 */}
      <Modal finalFocusRef={finalRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent borderRadius={20} mt={20}>
          <ModalHeader>
            <Heading fontSize={[24, 24, 40, 40]} fontWeight={600}>
              {" "}
              Select Job Post{" "}
            </Heading>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              {/* Job Role Components */}
              {posts?.map((post, idx) => (
                <Box
                  key={post?._id}
                  border="1px solid #D9D9D9"
                  borderRadius={20}
                  mb={2}
                  onClick={() => setSelectedJobId(post._id)}
                  style={
                    selectedJobId === post._id
                      ? { backgroundColor: "lightblue" }
                      : {}
                  }
                >
                  <Flex align="center" gap={2} p={4}>
                    <Box>
                      <Square borderRadius={5} size={55} bg="#D9D9D9">
                        {/* logo */}
                        <img src={companylogo} alt="" />
                      </Square>
                    </Box>
                    <Box>
                      <Text fontSize={20} fontWeight={600}>
                        {post.jobRoleTitle}
                      </Text>
                      <Text fontSize={16} fontWeight={600}>
                        {company[idx]}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              ))}
              {/* {jobData.map((item, idx) => (
                <Box
                  key={`job${idx}`}
                  border="1px solid #D9D9D9"
                  borderRadius={20}
                  mb={2}
                  onClick={() => setSelectedJob(item.id)}
                >
                  <Flex align="center" gap={2} p={4}>
                    <Box>
                      <Square borderRadius={5} size={55} bg="#D9D9D9"> */}
              {/* logo */}
              {/* </Square>
                    </Box>
                    <Box>
                      <Text fontSize={20} fontWeight={600}>
                        {item.name}
                      </Text>
                      <Text fontSize={16} fontWeight={600}>
                        {item.companyName}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              ))} */}
            </Box>
          </ModalBody>
          <ModalFooter>
            <Center>
              <Flex gap={5} mr={85}>
                <Flex
                  border="1px solid"
                  w={100}
                  py={2}
                  justify="center"
                  borderRadius={12}
                  cursor="pointer"
                  onClick={onClose}
                >
                  <Text fontSize={18} fontWeight={600} color="#2C2C2C">
                    Cancel
                  </Text>
                </Flex>
                <Flex
                  border="1px solid"
                  w={100}
                  py={2}
                  justify="center"
                  bg="#6C56FB"
                  cursor="pointer"
                  borderRadius={12}
                >
                  <Text
                    fontSize={18}
                    fontWeight={600}
                    color="#FFFFFF"
                    onClick={handleModalInvite}
                  >
                    Invite
                  </Text>
                </Flex>
              </Flex>
            </Center>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Modal 2 */}
      <Modal finalFocusRef={finalRef2} isOpen={isOpen2} onClose={onClose2}>
        <ModalOverlay />
        <ModalContent borderRadius={20} mt={200} maxW={600}>
          <ModalHeader>
            <Heading fontSize={40} fontWeight={600}>
              Send a message
            </Heading>
            <Text fontSize={16} fontWeight={400}>
              Write a message to candidate along with invite
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              {/* message area */}
              <Textarea
                bg="#F7F7F7"
                h={200}
                borderRadius={20}
                placeholder="Write here..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></Textarea>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Center>
              <Flex gap={5}>
                <Flex
                  border="1px solid"
                  w={100}
                  py={2}
                  justify="center"
                  borderRadius={40}
                  cursor="pointer"
                  onClick={onClose2}
                >
                  <Text fontSize={18} fontWeight={600} color="#2C2C2C">
                    Cancel
                  </Text>
                </Flex>
                <Flex
                  border="1px solid"
                  w={100}
                  py={2}
                  justify="center"
                  bg="#2C2C2C"
                  cursor="pointer"
                  borderRadius={40}
                  onClick={handleModal2Send}
                >
                  <Text fontSize={18} fontWeight={600} color="#FFFFFF">
                    Send
                  </Text>
                </Flex>
              </Flex>
            </Center>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};
export default SearchResult;
